import request from "../Utils/request";

export function multipleDelete(url: string, data?:any) {
  return request.delete(url,data);
}
